export const MuiPaper = () => {
  return {
    styleOverrides: {
      root: {
        boxShadow: 'none',
      },
    },
  };
};
